import { ColumnDef } from '@tanstack/react-table'
import { ClientDataTable } from 'components/ClientDataTable/ClientDataTable'
import { RouterLink } from 'components/UI/Anchor'
import Importer from 'features/importer/Importer'
import { ImportPreview } from 'features/importer/importer-types'
import { useGetImportPreviews } from 'features/importer/importer-api'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

export function ImportPreviewsPage() {
  const { data: importPreviews } = useGetImportPreviews()

  const columns = useMemo<ColumnDef<ImportPreview>[]>(() => {
    return [
      {
        header: 'Created',
        accessorKey: 'created',
      },
      {
        header: 'Updated',
        accessorKey: 'updated',
      },
      {
        header: 'Actions',
        accessorKey: 'actions',
        cell: ({ row }) => {
          return (
            <RouterLink to={`/importer/${row.original.id}`}>View</RouterLink>
          )
        },
      },
    ]
  }, [])

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold">Import Previews</h1>
        <RouterLink to="/importer/create">Create Import Preview</RouterLink>
      </div>
      <ClientDataTable columns={columns} data={importPreviews ?? []} />
    </div>
  )
}

export function ImportPreviewPage() {
  const { id } = useParams()
  console.log(id, 'heyefhysadihu')

  return <Importer importPreviewId={Number(id)} />
}

export function ImportPreviewCreatePage() {
  return <Importer importPreviewId={null} />
}
